const SETTING_ROUTES = Object.freeze({
	root: {
		name: 'SettingRoot',
		path: '/setting',
		meta: {
			layout: 'Default',
		},
		redirect: {
			name: 'Setting',
		},
		component: () => import('@/presentation/modules/setting/views/RootView.vue'),
	},
	setting: {
		name: 'Setting',
		path: '',
		component: () => import('@/presentation/modules/setting/views/SettingIndexView.vue'),
		meta: {
			requiresAuth: true,
		},
	},
	accountDetail: {
		name: 'SettingAccountDetail',
		path: 'account-detail',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/setting/views/AccountDetailView.vue'),
	},
	wallet: {
		name: 'SettingWallet',
		path: 'wallet',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/setting/views/WalletView.vue'),
	},
});

export default SETTING_ROUTES;
